import React from "react";
import { DefaultLayout, Grid } from "@client/shared/components";
import { noop } from "@client/shared/constants";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { globalStyles } from "@client/shared/constants";
import style from "./style";
import Users from "./users";
import WhiteList from "./white-list";

const TAB_LIST = [
  { id: 1, label: "Users" },
  { id: 2, label: "Whitelist" },
];

const UsersView = ({ tabIndex = 1, handleTabChange = noop }) => {
  return (
    <>
      <Box
        sx={{
          p: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            p: 3,
            ...style.pageTitleWrapper,
          }}
        >
          <Typography variant="h6">Admin</Typography>
          <Typography
            variant="body2"
            sx={{
              ...globalStyles.text.color.secondaryText,
            }}
          >
            Manage all app users, roles and view the whitelist for this
            application.
          </Typography>
        </Paper>
        <Tabs value={tabIndex} onChange={handleTabChange} indicatorColor={""}>
          {TAB_LIST.map((tab) => (
            <Tab
              value={tab.id}
              key={tab.id}
              name={tab.id}
              sx={{ px: 0, pb: 0 }}
              label={
                <Box
                  component={tab.id === tabIndex ? Paper : Box}
                  elevation={0}
                  sx={{ px: "32px", py: "10px", ...style.tabPaper }}
                >
                  <Typography variant="h6" component={"span"}>
                    {tab.label}
                  </Typography>
                </Box>
              }
            />
          ))}
        </Tabs>
        {tabIndex === 1 && <Users />}
        {tabIndex === 2 && <WhiteList />}
      </Box>
    </>
  );
};

export default UsersView;
